export const tagIds = {
  INVOICE: 14988279,
  PAID: 14988280,
};
